import React from "react";
import { Link } from "react-router-dom";
import { ROUTES } from "../../../../routes/routes";
import type { Swimmer } from "../../../../api/client/types/swimmer.types";

interface DisabledOptionsNoteProps {
  swimmer?: Swimmer;
  reportTypeName?: string; // e.g., "evento adverso", "novedad"
  additionalInfo?: string; // Optional additional information to include in the message
  gender?: "masculine" | "feminine"; // Gender of the reportTypeName for proper Spanish grammar
}

/**
 * DisabledOptionsNote
 * A reusable component for displaying notes about disabled form options.
 * Handles two scenarios:
 * - When swimmer exists: explains disabled options aren't associated with swimmer
 * - When no swimmer: explains disabled options require swimmer association
 */
export const DisabledOptionsNote: React.FC<DisabledOptionsNoteProps> = ({
  swimmer,
  reportTypeName = "novedad",
  additionalInfo,
  gender = "feminine", // Default to feminine for backward compatibility
}) => {
  // Determine the correct article and adjective based on gender
  const article = gender === "masculine" ? "algún" : "alguna";
  const adjective = gender === "masculine" ? "deshabilitado" : "deshabilitada";

  return (
    <div className="mt-3 p-3 bg-blue-50 border border-blue-200 rounded-md">
      <p className="text-sm text-blue-800">
        <span className="font-semibold">Nota:</span>{" "}
        {swimmer ? (
          <>
            Las opciones que están deshabilitadas no están asociadas a un
            bañista. Para crear {article} {reportTypeName} {adjective}, por
            favor diríjase a este{" "}
            <Link
              to={ROUTES.NEWS.REGISTER}
              className="text-blue-600 hover:text-blue-800 underline font-medium"
            >
              sitio
            </Link>
            .
          </>
        ) : (
          <>
            Las opciones que están deshabilitadas requieren estar asociadas a
            un bañista.
            {additionalInfo && <> {additionalInfo}</>} Para crear {article}{" "}
            {reportTypeName} {adjective}, por favor diríjase a la{" "}
            <Link
              to={ROUTES.DASHBOARD.LIFEGUARD}
              className="text-blue-600 hover:text-blue-800 underline font-medium"
            >
              tabla de bañistas
            </Link>
            .
          </>
        )}
      </p>
    </div>
  );
};

